"use client";
import FlowPayTransactionsTable from "@/components/dashboard/transactions/FlowPayTransactionsTable";
import Pagination from "@/components/dashboard/pagination/Pagination";
import Filter from "@/components/dashboard/transactions/Filter";
import { PaylioContext } from "@/context/context";
import Image from "@/components/AppImage";
import Link from "@/components/common/DashboardLink";
import { useContext } from "react";
import csv from "/public/images/icon/csv.png";
import excel from "/public/images/icon/excel.png";
import pdf from "/public/images/icon/pdf.png";
import printer from "/public/images/icon/printer.png";
import search from "/public/images/icon/search.png";

const TransactionsMain = () => {
  const { activeLefMenu } = useContext(PaylioContext);
  return (
    <section
      className={`dashboard-section transactions ${
        activeLefMenu ? "body-collapse" : ""
      }`}>
      <div className="overlay pt-120">
        <div className="container-fruid">
          <div className="head-area">
            <div className="row">
              <div className="col-lg-5 col-md-4">
                <h4>Transactions</h4>
                <p className="mdr mb-0 mt-2">
                  ACH, Polygon USDC, and optional POL auto-convert
                </p>
              </div>
              <div className="col-lg-7 col-md-8">
                <div className="transactions-right d-flex align-items-center">
                  <form action="#" className="flex-fill">
                    <div className="form-group d-flex align-items-center">
                      <Image src={search} alt="icon" />
                      <input
                        type="text"
                        placeholder="Search ACH, wallets, hashes…"
                      />
                    </div>
                  </form>
                  <Link href="#">Monthly Statement</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="transactions-main">
                <div className="top-items">
                  <h6>All Transactions</h6>
                  <div className="export-area">
                    <ul className="d-flex align-items-center">
                      <li>
                        <Link href="#">
                          <Image src={printer} alt="icon" />
                          Print
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <Image src={excel} alt="icon" />
                          Excel
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <Image src={pdf} alt="icon" />
                          PDF
                        </Link>
                      </li>
                      <li>
                        <Link href="#">
                          <Image src={csv} alt="icon" />
                          CSV
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Filter */}
                <Filter />
                <div className="mt-4">
                  <FlowPayTransactionsTable />
                </div>
                <div className="mt-4">
                  <Pagination />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransactionsMain;
